import React from 'react';
import SidebarSection from '../../../components/sideBar/SidebarSection';
import { useZitoneoHotelPresentation } from '../../../contexts/ZitoneoContentContext';
import ContentStatusSection from './ContentStatusSection';
import useTranslate from '../../../../../customHooks/useTranslate';
import {
    calculateContentStatusPercentage,
    calculateGlobalContentScore,
    getSubtextForGlobalContentScore,
} from '../../../utils/zitoneoContentScoreUtils';
import { LinearProgress } from '@mui/material';

const ContentStatus = () => {
    const translate = useTranslate();
    const { stats } = useZitoneoHotelPresentation();
    const {
        totalAttributes,
        filledAttributes,
        totalServiceInstances,
        totalServiceInstancesDescribed,
        totalRoomTypes,
        roomsWithServices,
        totalRoomAttributes,
        filledRoomAttributes,
        totalRoomServiceInstances,
        totalRoomServiceInstancesDescribed,
        totalImageCategories,
        coveredImageCategories,
        roomsWithImages,
    } = stats;

    const hotelServiceStatusItems = [
        {
            label: 'filled_attributes',
            value: filledAttributes,
            maxValue: totalAttributes,
        },
        {
            label: 'services_described',
            value: totalServiceInstancesDescribed,
            maxValue: totalServiceInstances,
        },
    ];
    const roomServiceStatusItems = [
        {
            label: 'rooms_with_services',
            value: roomsWithServices,
            maxValue: totalRoomTypes,
        },
        {
            label: 'filled_attributes',
            value: filledRoomAttributes,
            maxValue: totalRoomAttributes,
        },
        {
            label: 'rooms_services_described',
            value: totalRoomServiceInstancesDescribed,
            maxValue: totalRoomServiceInstances,
        },
    ];
    const imageStatusItems = [
        {
            label: 'categories_covered',
            value: coveredImageCategories,
            maxValue: totalImageCategories,
        },
        {
            label: 'rooms_with_images',
            value: roomsWithImages,
            maxValue: totalRoomTypes,
        },
    ];
    const globalContentScore = calculateGlobalContentScore({
        HOTEL_SERVICES: calculateContentStatusPercentage(
            hotelServiceStatusItems
        ),
        ROOM_SERVICES: calculateContentStatusPercentage(roomServiceStatusItems),
        IMAGES: calculateContentStatusPercentage(imageStatusItems),
    });

    return (
        <SidebarSection title='content_status' containerClassName='gap-20'>
            <header className='content-status__header'>
                <h3 className='content-status__score'>
                    <span style={{ color: globalContentScore.color }}>
                        {globalContentScore.percentage.toFixed(0)}
                    </span>{' '}
                    / 100
                </h3>
                {translate(
                    getSubtextForGlobalContentScore(globalContentScore.level)
                )}
                <LinearProgress
                    variant='determinate'
                    value={globalContentScore.percentage}
                    sx={{
                        '& .MuiLinearProgress-bar': {
                            backgroundColor: globalContentScore.color,
                        },
                    }}
                />
            </header>
            <main className='content-status__main'>
                <ContentStatusSection
                    title='hotel_services'
                    statusItems={hotelServiceStatusItems}
                />
                <ContentStatusSection
                    title='room_services'
                    statusItems={roomServiceStatusItems}
                />
                <ContentStatusSection
                    title='images'
                    statusItems={imageStatusItems}
                />
            </main>
        </SidebarSection>
    );
};

export default ContentStatus;
